import { t as e } from "./utils-DiFe-_ei.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/media/Avatar/Avatar.tsx
var n = [
	"bg-blue-700",
	"bg-violet-600",
	"bg-emerald-700",
	"bg-amber-700",
	"bg-rose-700",
	"bg-cyan-700",
	"bg-indigo-600",
	"bg-teal-700",
	"bg-orange-700",
	"bg-pink-700"
], r = {
	xs: "size-5 text-[9px]",
	sm: "size-8 text-[11px]",
	md: "size-10 text-[13px]",
	lg: "size-14 text-base"
};
function i(e) {
	return e.trim().split(/\s+/).slice(0, 2).map((e) => e[0]?.toUpperCase() ?? "").join("");
}
function a(e) {
	return n[Array.from(e).reduce((e, t) => e + t.charCodeAt(0), 0) % n.length];
}
function o({ name: n, size: o = "md", shape: s = "circle", className: c }) {
	return /* @__PURE__ */ t("div", {
		className: e("flex shrink-0 items-center justify-center font-semibold text-white", s === "square" ? "rounded-md" : "rounded-full", r[o], a(n), c),
		children: /* @__PURE__ */ t("span", {
			className: "[text-box:trim-both_cap_alphabetic]",
			children: i(n)
		})
	});
}
//#endregion
export { o as t };

//# sourceMappingURL=Avatar-DPnco3PK.js.map